export default "__VITE_ASSET__x1K$TmIM__"